
import { MapPin, Phone, Mail, Send, SendIcon } from 'lucide-react';
import { Companydata } from '../companydata';
import { useRef, useState } from 'react';

import emailjs from '@emailjs/browser';

const ContactSection = () => {
  const formRef = useRef();
  const [status, setStatus] = useState('');

  const handleSendEmail = (e) => {
    e.preventDefault();
    setStatus('Sending...');

    // Replace these with your actual IDs from emailjs.com
    const SERVICE_ID = 'deven_v';
    const TEMPLATE_ID = 'deven_email_template';
    const PUBLIC_KEY = 'sEYDvqOGNgc8Z5SJ2';

    emailjs.sendForm(SERVICE_ID, TEMPLATE_ID, formRef.current, PUBLIC_KEY)
      .then(() => {
        setStatus('Message sent successfully!');
        formRef.current.reset(); // Clears the form
      }, (error) => {
        setStatus('Failed to send. Please try again.');
        console.error(error);
      });
  };
  return (
    <section className="contact py-10 position-relative bg-light">
      <div className="overlay"></div>
      <div className="container position-relative pb-8">
        <div className="contact-inner text-center text-lg-start">
          <div className="row gx-xl-5 gy-5 align-items-center">

            {/* Left Side: Contact Information */}
            <div className="col-lg-6">
              <div className="section-left">
                <div className="section-title mb-4">
                  <h6 className="text-uppercase fw-medium green mb-1">Get In Touch</h6>
                  <h2 className="ps-4 border-start border-3 border-green mb-4 text-dark fw-bold">
                    Feel free to <span className="green">contact and reach us</span> for expert infrastructure info
                  </h2>
                </div>
                <div className="section-body">
                  <p className="mb-4 text-muted">
                    Denial Enterprise is ready to support your MNC infrastructure needs, from
                    site feasibility to final commissioning of HT/LT electrical networks.
                  </p>

                  <div className="contact-info">
                    <div className="row gy-4">
                      {/* Address Box */}
                      <div className="col-lg-12">
                        <div className="contact-info-box bg-white text-md-start d-md-flex align-items-center p-4 border border-2 border-lightgreen rounded-4 shadow-sm hover-lift">
                          <div className="contact-icon me-4 mb-3 mb-md-0">
                            <div className="bg-green rounded-circle p-3 d-inline-flex text-white">
                              <MapPin size={28} />
                            </div>
                          </div>
                          <div className="contact-box-info">
                            <h5 className="mb-1 fw-bold">Location Address:</h5>
                            <span className="text-muted">{Companydata[0].address}</span>
                          </div>
                        </div>
                      </div>

                      {/* Phone Box */}
                      <div className="col-md-6">
                        <div className="contact-info-box bg-white p-4 border border-2 border-lightgreen rounded-4 shadow-sm h-100 hover-lift">
                          <div className="contact-icon mb-4">
                            <div className="bg-green rounded-circle p-3 d-inline-flex text-white">
                              <Phone size={28} />
                            </div>
                          </div>
                          <div className="contact-box-info">
                            <h5 className="mb-1 fw-bold">Phone Number:</h5>
                            <span><a href="tel:+91XXXXXXXXXX" className="text-muted text-decoration-none">{Companydata[0].phoneno}</a></span>
                          </div>
                        </div>
                      </div>

                      {/* Email Box */}
                      <div className="col-md-6">
                        <div className="contact-info-box bg-white p-4 border border-2 border-lightgreen rounded-4 shadow-sm h-100 hover-lift">
                          <div className="contact-icon mb-4">
                            <div className="bg-green rounded-circle p-3 d-inline-flex text-white">
                              <Mail size={28} />
                            </div>
                          </div>
                          <div className="contact-box-info">
                            <h5 className="mb-1 fw-bold">Email Address:</h5>
                            <span><a href="mailto:deven.v@denialenterprise.com" className="text-muted text-decoration-none small">{Companydata[0].emailid}</a></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Side: Contact Form */}
            <div className="col-lg-6">
              <div className="section-right">
                <div className="section-title mb-4">
                  <h6 className="text-uppercase fw-medium green mb-1">Contact Us</h6>
                  <h2 className="ps-4 border-start border-3 border-green mb-2 fw-bold">Send your <span className="green">Message</span></h2>
                  <p className="text-muted">Our engineering team is ready to answer all your technical questions.</p>
                </div>

                <div className="contact-form p-5 border border-2 border-lightgreen rounded-4 bg-white shadow-sm">
                  <form ref={formRef} onSubmit={handleSendEmail}>
                    <div className="row">
                      <div className="col-md-6 mb-4">
                        <input type="text" name='user_name' className="form-control bg-light border-0 p-3" placeholder="Your Name..." required />
                      </div>
                      <div className="col-md-6 mb-4">
                        <input type="email" name='email' className="form-control bg-light border-0 p-3" placeholder="Your Email..." required />
                      </div>
                      <div className="col-md-6 mb-4">
                        <input type="number" name='user_phoneno' className="form-control bg-light border-0 p-3" placeholder="Phone No..." />
                      </div>
                      <div className="col-md-6 mb-4">
                        <input type="text" name='subject' className="form-control bg-light border-0 p-3" placeholder="Your Subject..." />
                      </div>
                      <div className="col-12 mb-4">
                        <textarea rows="4" name='user_msg' className="form-control bg-light border-0 p-3" placeholder="Enter your Message..."></textarea>
                      </div>
                      <div className="col-12">
                        <button type="submit" className="btn btn-success px-5 py-3 rounded-pill fw-bold d-inline-flex align-items-center gap-2">
                          Send Message <SendIcon size={20} />
                        </button>
                        {status && (
                          <div className={`mt-3 p-2 rounded text-center fw-bold ${status.includes('successfully') ? 'text-success' : 'text-danger'}`}>
                            {status}
                          </div>
                        )}
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;